import { Clock, UserCheck, Package, Truck, CheckCircle2, X, CreditCard, Warehouse, ArrowRightLeft } from "lucide-react";

const statusConfig = {
  pending_payment: { bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200", icon: CreditCard, label: "Awaiting Payment", dot: "bg-amber-500" },
  pending:   { bg: "bg-slate-50", text: "text-slate-600", border: "border-slate-200", icon: Clock, label: "Pending", dot: "bg-slate-400" },
  assigned:  { bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200", icon: UserCheck, label: "Assigned", dot: "bg-blue-500" },
  pickup_assigned: { bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200", icon: UserCheck, label: "Pickup Assigned", dot: "bg-blue-500" },
  picked_up: { bg: "bg-orange-50", text: "text-[#FF6B00]", border: "border-orange-200", icon: Package, label: "Picked Up", dot: "bg-[#FF6B00]" },
  at_origin_hub: { bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200", icon: Warehouse, label: "At Origin Hub", dot: "bg-amber-500" },
  in_linehaul: { bg: "bg-violet-50", text: "text-violet-700", border: "border-violet-200", icon: ArrowRightLeft, label: "In Linehaul", dot: "bg-violet-500" },
  at_dest_hub: { bg: "bg-teal-50", text: "text-teal-700", border: "border-teal-200", icon: Warehouse, label: "At Dest Hub", dot: "bg-teal-500" },
  out_for_delivery: { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", icon: Truck, label: "Out for Delivery", dot: "bg-emerald-500" },
  in_transit:{ bg: "bg-orange-50", text: "text-[#FF6B00]", border: "border-orange-200", icon: Truck, label: "In Transit", dot: "bg-[#FF6B00]" },
  delivered: { bg: "bg-green-50", text: "text-green-700", border: "border-green-200", icon: CheckCircle2, label: "Delivered", dot: "bg-green-500" },
  cancelled: { bg: "bg-red-50", text: "text-red-600", border: "border-red-200", icon: X, label: "Cancelled", dot: "bg-red-500" },
};

export { statusConfig };

export default function StatusBadge({ status, size = "sm" }) {
  const cfg = statusConfig[status] || statusConfig.pending;
  const Icon = cfg.icon;
  const isSmall = size === "sm";

  return (
    <span
      className={`status-badge inline-flex items-center gap-1.5 font-semibold border ${cfg.bg} ${cfg.text} ${cfg.border} ${
        isSmall ? "px-2.5 py-1 rounded-lg text-xs" : "px-3 py-1.5 rounded-xl text-sm"
      }`}
      data-testid={`status-badge-${status}`}
    >
      <Icon className={isSmall ? "h-3 w-3" : "h-4 w-4"} />
      {cfg.label}
    </span>
  );
}
